import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthContext } from 'modules/auth/context';
import { updateReminder } from './api';
import type { ReminderUpdate } from './types';
import { reminderKey } from './useReminderSettings';

/**
 * Turns reminders on or off, or changes their hour or language. The returned settings replace
 * the cached ones; `delivery` (how the confirmation message went) belongs to this one call, so
 * it is handed to the caller and not cached.
 */
export function useUpdateReminder() {
  const { state } = useAuthContext();
  const queryClient = useQueryClient();
  const userId = state.user?.id;

  return useMutation({
    mutationFn: (input: ReminderUpdate) => updateReminder(input),
    onSuccess: async ({ delivery: _delivery, ...settings }) => {
      // A refetch that started before this change would land after it and put the old settings back.
      await queryClient.cancelQueries({ queryKey: reminderKey(userId) });
      queryClient.setQueryData(reminderKey(userId), settings);
    },
  });
}
